import { metadata } from '../../core/metadata.js'
import { articleSetup } from '../../core/articleSetup.js'
import { footer } from '../../projections/footer.js'

// ******************** //
import { header } from './sections/header.js'

import { postBody } from '../../core/postBody.js'

export function article(category, slug) {
	return groq`*[_type == 'page.article' && metadata.slug.current == "${slug}"][0] {
    "type": _type,
    "category": articleSetup.category->name,
    "metadata": metadata{...${metadata()}},
    "articleSetup": articleSetup{...${articleSetup()}},
    "footer":{...${footer()}},
    "sections": sections[] {
      _type,
      _type == 'header' => {${header}},
      _type == 'body' => {
        ${postBody()},
        "legalDisclaimer": coalesce(
          *[_type == 'page.article' && metadata.slug.current == "${slug}"][0].articleSetup.legalDisclaimer,
          *[_type == 'sharedContent'][0].articles.legalDisclaimer
        )
      }
    }
  }
`
}
